// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import LOGO from "assets/images/logos/st/st_color_white_bg.png";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import bgImage from "assets/images/cover/bg-blue.png";

function BuiltByDevelopers() {
  // const bgImage = "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/soft-ui-design-system/assets/img/desktop.jpg";

  return (
    <MKBox
      display="flex"
      alignItems="center"
      borderRadius="xl"
      my={10}
      py={6}
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0),
            rgba(gradients.dark.state, 0.5)
          )}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Grid container justifyContent="center" alignItems="center" spacing={4}>
          {/* Logo */}
          <Grid
            container
            item
            xs={12}
            md={4}
            lg={2}
            sx={{ ml: { xs: 0, lg: 6 } }}
            justifyContent="center"
          >
            <MKBox component="img" src={LOGO} alt="logo" width="100%" />
          </Grid>

          {/* Text content */}
          <Grid
            container
            item
            xs={12}
            md={8}
            sx={{
              ml: { xs: 0, lg: 6 },
              textAlign: "start",
              flexDirection: "column",
              alignItems: "center", // centers child content horizontally
            }}
          >
            <MKTypography
              variant="h2"
              color="white"
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("lg")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              We’re a bold production house and content studio — where creative ideas take shape and
              stories come to life.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default BuiltByDevelopers;
